'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DropdownTrigger = require('./components/DropdownTrigger.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropdownTrigger).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown-trigger/index.js
// module id = 519
// module chunks = 1